/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: bar-graph-component.ts
 *
 * Created by randysorensen on 2019-02-22.
 */

function BarGraphController (
    this: JS5Object,
    _: JS5Object
) {

    this.getBars = () => {
        return this.barGraphData.bars;
    };

    this.isLastBar = (index: string) => {
        let lastIndex = _
            .chain(this.barGraphData.bars)
            .keys()
            .sort()
            .last()
            .value();
        return index === lastIndex;
    };

    const getOrderOfMagnitude = (value: number) => {
        let oom = 1;
        while (oom * 10 < value) {
            oom *= 10;
        }
        return oom;
    };

    const getMaxScale = (): number => {
        let maxValue = _
            .chain(this.barGraphData.bars)
            .map('value')
            .max()
            .value();
        let oom = getOrderOfMagnitude(maxValue);
        let max = oom;
        while (max < maxValue) {
            max += oom;
        }
        return max;
    };

    this.getScaleLines = () => {
        return {
            max: getMaxScale(),
            threeFourths: '',
            half: getMaxScale() / 2,
            oneFourth: '',
            zero: ''
        };
    };

    this.getAnimationDuration = () => {
        let source = this.barGraphData.animationDuration;
        let result;
        if (typeof(source) === 'function') {
            result = source();
        } else {
            result = parseFloat(source) || 0;
        }

        let dataAge = (new Date().getTime() - this.barGraphData.timeStamp.getTime()) / 1000;
        if (dataAge > result) {
            result = 0;
        }
        return result;
    };

    this.getHeight = (bar: JS5Object) => {
        return 100.0 * parseFloat(bar.value) / getMaxScale();
    };

    this.$onInit = () => {
    };

}

angular.module('prism-ui.components').component('barGraph', {
    controller: BarGraphController,
    templateUrl: 'components/visual/bar-graph/bar-graph-template.html',
    bindings: {
        barGraphData: '<'
    }
});
